import { message, Modal } from "antd";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CustomInput from "./CustomInput";
import { verifyLength, verifyNumber } from "../../../variables/functions";
import { FormDatePicker, FormSelect } from "../../../components/forms/FormInputs";
import dayjs from "dayjs";
import axiosInstance from "../../../variables/api/axiosInstance";

const styles = {
    pageSubcategoriesTitle: {
        color: "#3C4858",
        textDecoration: "none",
        textAlign: "center",
    },
    cardCategory: {
        margin: "0",
        color: "#999999",
    },
};

const AssignCheque = (prop) => {
    const [modalDecaissementSinistre, setModalDecaissementSinistre] = useState(
        false
    );
    const [numChequeState, setNumChequeState] = useState("");
    const [numeroCheque, setNumeroCheque] = useState("");
    // const [cheque, setCheque] = useState("");
    const [dateEmissionCheque, setDateEmissionCheque] = useState(dayjs()); //
    // const [cni, setCni] = useState("");
    const [banque, setBanque] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleDecaissementSubmit = async () => {
        setLoading(true);
        const decaissement = prop?.decaissement;
        if (!decaissement) {
            message.error("Erreur lors du décaissement");
            setLoading(false);
            return;
        }

        // Controles cote frontend
        if (!numeroCheque || numeroCheque.trim().length < 5) {
            message.error("Numero de cheque obligatoire (5 caracteres min)");
            setLoading(false);
            return;
        }
        if (!banque) {
            message.error("Banque obligatoire");
            setLoading(false);
            return;
        }

        // Construction du ChequeDTO (format backend)
        const chequeDTO = {
            numeroCheque: numeroCheque.trim(),
            banque: banque,
            dateCheque: dateEmissionCheque.format('YYYY-MM-DD'),
            montantCheque: decaissement.montantGlobal,
            // representant: ... si champ ajoute au formulaire
        };

        try {
            const res = await axiosInstance.put(
                `/api/decaissement/assigner-cheque/${decaissement.codeId}`,
                JSON.stringify(chequeDTO),
                { headers: { 'Content-Type': 'application/json' } }
            );

            message.success("Chèque assigné avec succès");
            setModalDecaissementSinistre(false);
            setNumeroCheque("");
            setNumChequeState("");
            // IMPORTANT: res.data.codeId est le NOUVEAU codeId. Le transmettre
            // au composant parent si celui-ci va enchainer avec une remise.
            if (prop.onSuccess) prop.onSuccess(res.data);
            else window.location.reload();
        } catch (err) {
            console.log(err);
            const msg = err?.response?.data?.message || "Erreur lors de l'assignation du chèque";
            message.error(msg);
        } finally {
            setLoading(false);
        }
    };

    const getFrenchDate = () => {
        const now = dayjs();
        return now.format("DD-MM-YYYY");
    };

    useEffect(() => {
        console.log(prop.decaissement);
        setModalDecaissementSinistre(prop.open);
    }, [prop.open]);


    return (
        <Modal
            title={prop?.decaissement?.encaissement ? "Enregistrer l'encaissement" : "Effectuer le décaissement"}
            confirmLoading={loading}
            centered
            open={modalDecaissementSinistre}
            onOk={() => handleDecaissementSubmit()}
            onCancel={prop.onCancel}
            okText={"Effectuer"}
            cancelText={"Annuler"}
            width={900}
        >
            <div className="row">
                <div className="col-6">

                    <CustomInput
                        success={numChequeState === "success"}
                        error={numChequeState === "error"}
                        labelText={
                            <span>
                                Numéro de chèque<small>(Obligatoire)</small>
                            </span>
                        }
                        id="numeroCheque"
                        formControlProps={{
                            fullWidth: true,
                        }}
                        value={numeroCheque}
                        onChange={(event) => {
                            if (verifyLength(event.target.value, 5)) {
                                // setmembreRaisonState("success");
                                if (verifyNumber(event.target.value)) {
                                    setNumChequeState("success");
                                } else {
                                    setNumChequeState("error");
                                }
                            } else {
                                setNumChequeState("error");
                            }
                            setNumeroCheque(event.target.value);
                        }}
                        inputProps={{
                            endAdornment: (
                                <div className={styles.inputAdornment} style={{
                                    position: "end"
                                }}
                                ></div>
                            ),
                            name: "numeroCheque",
                            id: "numChequeState",
                        }}
                    />
                </div>
                <div className="col-6" style={{ margin: "-20px 0 10px 0", }}>
                    <FormDatePicker
                        name={'dateEmissionCheque'}
                        value={dateEmissionCheque}
                        label={`Date d'émission du chèque`}
                        format={`DD/MM/YYYY`}
                        onBlur={() => {
                            return
                        }}
                        onChange={(date) => setDateEmissionCheque(date)}
                        maxDate={dayjs(getFrenchDate(), 'DD-MM-YYYY')}
                        style={{ padding: "50px" }}
                    />

                </div>
                <div className="col-6" style={{ margin: "-10px 0 10px 0", }}>
                    <FormSelect
                        label="Banque *"
                        name="banque"
                        value={banque}
                        onBlur={() => console.log("blur")}
                        onChange={(event) => {
                            setBanque(event.target.value);
                        }} options={[{ label: "ORABANK", value: "ORABANK" }, { label: "IB BANK", value: "IB BANK" }, { label: "UTB", value: "UTB" }]}
                    />
                </div>
                <br />
                {/* <div className="col-6" style={{ justifyContent: 'center', marginTop: '5%' }}>
                    <Dragger {...props}>
                        <Button icon={<UploadOutlined />}>
                            Joindre le fichier du chèque
                        </Button>
                    </Dragger>
                </div>
                <br />
                <div className="col-6" style={{ justifyContent: 'center', marginTop: '5%' }}>
                    <Dragger {...props2}>
                        <Button icon={<UploadOutlined />}>
                            Joindre la CNI endossant le chèque
                        </Button>
                    </Dragger>
                </div> */}
            </div>
        </Modal>
    );
};

AssignCheque.propTypes = {
    open: PropTypes.bool,
    // setOpen: PropTypes.func,
    decaissement: PropTypes.object,
    sinistre: PropTypes.object,
};

export default AssignCheque;
